import { createElementProxy } from '../utils';
export const ForgeAccordion = createElementProxy('forge-accordion');
export const ForgeAppBar = createElementProxy('forge-app-bar');
export const ForgeAppBarHelpButton = createElementProxy('forge-app-bar-help-button');
export const ForgeAppBarMenuButton = createElementProxy('forge-app-bar-menu-button');
export const ForgeAppBarNotificationButton = createElementProxy('forge-app-bar-notification-button');
export const ForgeAppBarProfileButton = createElementProxy('forge-app-bar-profile-button');
export const ForgeAppBarSearch = createElementProxy('forge-app-bar-search');
export const ForgeAutocomplete = createElementProxy('forge-autocomplete');
export const ForgeAvatar = createElementProxy('forge-avatar');
export const ForgeBackdrop = createElementProxy('forge-backdrop');
export const ForgeBadge = createElementProxy('forge-badge');
export const ForgeBanner = createElementProxy('forge-banner');
export const ForgeBottomSheet = createElementProxy('forge-bottom-sheet');
export const ForgeButtonArea = createElementProxy('forge-button-area');
export const ForgeButton = createElementProxy('forge-button');
export const ForgeButtonToggleGroup = createElementProxy('forge-button-toggle-group');
export const ForgeButtonToggle = createElementProxy('forge-button-toggle');
export const ForgeCalendar = createElementProxy('forge-calendar');
export const ForgeCard = createElementProxy('forge-card');
export const ForgeCheckbox = createElementProxy('forge-checkbox');
export const ForgeChipField = createElementProxy('forge-chip-field');
export const ForgeChipSet = createElementProxy('forge-chip-set');
export const ForgeChip = createElementProxy('forge-chip');
export const ForgeCircularProgress = createElementProxy('forge-circular-progress');
export const ForgeColorPicker = createElementProxy('forge-color-picker');
export const ForgeDateRangePicker = createElementProxy('forge-date-range-picker');
export const ForgeDatePicker = createElementProxy('forge-date-picker');
export const ForgeDeprecatedButton = createElementProxy('forge-deprecated-button');
export const ForgeDeprecatedIconButton = createElementProxy('forge-deprecated-icon-button');
export const ForgeDialog = createElementProxy('forge-dialog');
export const ForgeDivider = createElementProxy('forge-divider');
export const ForgeDrawer = createElementProxy('forge-drawer');
export const ForgeMiniDrawer = createElementProxy('forge-mini-drawer');
export const ForgeModalDrawer = createElementProxy('forge-modal-drawer');
export const ForgeExpansionPanel = createElementProxy('forge-expansion-panel');
export const ForgeField = createElementProxy('forge-field');
export const ForgeFilePicker = createElementProxy('forge-file-picker');
export const ForgeFloatingActionButton = createElementProxy('forge-fab');
export const ForgeFocusIndicator = createElementProxy('forge-focus-indicator');
export const ForgeIcon = createElementProxy('forge-icon');
export const ForgeIconButton = createElementProxy('forge-icon-button');
export const ForgeInlineMessage = createElementProxy('forge-inline-message');
export const ForgeKey = createElementProxy('forge-key');
export const ForgeKeyboardShortcut = createElementProxy('forge-keyboard-shortcut');
export const ForgeKeyItem = createElementProxy('forge-key-item');
export const ForgeLabelValue = createElementProxy('forge-label-value');
export const ForgeLinearProgress = createElementProxy('forge-linear-progress');
export const ForgeList = createElementProxy('forge-list');
export const ForgeListItem = createElementProxy('forge-list-item');
export const ForgeMenu = createElementProxy('forge-menu');
export const ForgeMeter = createElementProxy('forge-meter');
export const ForgeMeterGroup = createElementProxy('forge-meter-group');
export const ForgeOpenIcon = createElementProxy('forge-open-icon');
export const ForgeOverlay = createElementProxy('forge-overlay');
export const ForgePageState = createElementProxy('forge-page-state');
export const ForgePaginator = createElementProxy('forge-paginator');
export const ForgePopover = createElementProxy('forge-popover');
export const ForgeOption = createElementProxy('forge-option', { forceProperty: ['value'] });
export const ForgeOptionGroup = createElementProxy('forge-option-group');
export const ForgeProfileCard = createElementProxy('forge-profile-card');
export const ForgeRadio = createElementProxy('forge-radio');
export const ForgeScaffold = createElementProxy('forge-scaffold');
export const ForgeSelect = createElementProxy('forge-select');
export const ForgeSelectDropdown = createElementProxy('forge-select-dropdown');
export const ForgeSkeleton = createElementProxy('forge-skeleton');
export const ForgeSlider = createElementProxy('forge-slider');
export const ForgeSplitButton = createElementProxy('forge-split-button');
export const ForgeSplitView = createElementProxy('forge-split-view');
export const ForgeSplitViewPanel = createElementProxy('forge-split-view-panel');
export const ForgeStack = createElementProxy('forge-stack');
export const ForgeStateLayer = createElementProxy('forge-state-layer');
export const ForgeStepper = createElementProxy('forge-stepper');
export const ForgeStep = createElementProxy('forge-step');
export const ForgeSwitch = createElementProxy('forge-switch');
export const ForgeTable = createElementProxy('forge-table');
export const ForgeTabBar = createElementProxy('forge-tab-bar');
export const ForgeTab = createElementProxy('forge-tab');
export const ForgeTextField = createElementProxy('forge-text-field');
export const ForgeTimePicker = createElementProxy('forge-time-picker');
export const ForgeToast = createElementProxy('forge-toast');
export const ForgeToolbar = createElementProxy('forge-toolbar');
export const ForgeTooltip = createElementProxy('forge-tooltip');
export const ForgeViewSwitcher = createElementProxy('forge-view-switcher');
export const ForgeView = createElementProxy('forge-view');
